module.exports = __webpack_public_path__ + "assets/img/4.5cc24011.jpg";